import React from 'react';
import Icon from 'components/AppIcon';

const FilterPanel = ({ filters, setFilters, onClose }) => {
  const statusOptions = ['Active', 'Pending', 'Completed'];
  const matterTypeOptions = [
    'Commercial Litigation',
    'Criminal Defense',
    'Family Law',
    'Land & Property',
    'Corporate Law',
    'Constitutional Law',
    'Employment Law',
    'Tax Law'
  ];
  const lawyerOptions = [
    'Sarah Mwangi',
    'Michael Ochieng',
    'Patricia Wanjiru',
    'David Mutua',
    'Grace Kimani',
    'James Otieno'
  ];
  const jurisdictionOptions = [
    'High Court - Nairobi',
    'High Court - Mombasa',
    'High Court - Nakuru',
    'High Court - Eldoret',
    'Magistrate Court - Nairobi',
    'Magistrate Court - Eldoret',
    'Court of Appeal - Nairobi'
  ];

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleDateRangeChange = (type, value) => {
    setFilters(prev => ({
      ...prev,
      dateRange: {
        ...prev.dateRange,
        [type]: value
      }
    }));
  };

  const clearAllFilters = () => {
    setFilters({
      status: '',
      matterType: '',
      assignedLawyer: '',
      courtJurisdiction: '',
      dateRange: { start: '', end: '' }
    });
  };

  const hasActiveFilters = Object.values(filters).some(value => {
    if (typeof value === 'object') {
      return Object.values(value).some(v => v !== '');
    }
    return value !== '';
  });

  return (
    <div className="bg-secondary-50 border-b border-border px-6 py-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium text-text-primary">Filter Cases</h3>
        <div className="flex items-center gap-2">
          {hasActiveFilters && (
            <button
              onClick={clearAllFilters}
              className="text-sm text-accent hover:text-accent-700 transition-smooth"
            >
              Clear All
            </button>
          )}
          <button
            onClick={onClose}
            className="text-text-secondary hover:text-text-primary transition-smooth"
          >
            <Icon name="X" size={20} />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
        {/* Status Filter */}
        <div>
          <label className="block text-sm font-medium text-text-primary mb-2">
            Case Status
          </label>
          <select
            value={filters.status}
            onChange={(e) => handleFilterChange('status', e.target.value)}
            className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          >
            <option value="">All Statuses</option>
            {statusOptions.map(status => (
              <option key={status} value={status}>{status}</option>
            ))}
          </select>
        </div>

        {/* Matter Type Filter */}
        <div>
          <label className="block text-sm font-medium text-text-primary mb-2">
            Matter Type
          </label>
          <select
            value={filters.matterType}
            onChange={(e) => handleFilterChange('matterType', e.target.value)}
            className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          >
            <option value="">All Matter Types</option>
            {matterTypeOptions.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>

        {/* Assigned Lawyer Filter */}
        <div>
          <label className="block text-sm font-medium text-text-primary mb-2">
            Assigned Advocate
          </label>
          <select
            value={filters.assignedLawyer}
            onChange={(e) => handleFilterChange('assignedLawyer', e.target.value)}
            className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          >
            <option value="">All Advocates</option>
            {lawyerOptions.map(lawyer => (
              <option key={lawyer} value={lawyer}>{lawyer}</option>
            ))}
          </select>
        </div>

        {/* Court Jurisdiction Filter */}
        <div>
          <label className="block text-sm font-medium text-text-primary mb-2">
            Court Jurisdiction
          </label>
          <select
            value={filters.courtJurisdiction}
            onChange={(e) => handleFilterChange('courtJurisdiction', e.target.value)}
            className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          >
            <option value="">All Jurisdictions</option>
            {jurisdictionOptions.map(jurisdiction => (
              <option key={jurisdiction} value={jurisdiction}>{jurisdiction}</option>
            ))}
          </select>
        </div>

        {/* Date Range Filter */}
        <div>
          <label className="block text-sm font-medium text-text-primary mb-2">
            Date Range
          </label>
          <div className="space-y-2">
            <input
              type="date"
              value={filters.dateRange.start}
              onChange={(e) => handleDateRangeChange('start', e.target.value)}
              className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
              placeholder="Start date"
            />
            <input
              type="date"
              value={filters.dateRange.end}
              onChange={(e) => handleDateRangeChange('end', e.target.value)}
              className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
              placeholder="End date"
            />
          </div>
        </div>
      </div>

      {/* Active Filters Display */}
      {hasActiveFilters && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex flex-wrap gap-2">
            {filters.status && (
              <span className="inline-flex items-center gap-1 px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-sm">
                Status: {filters.status}
                <button
                  onClick={() => handleFilterChange('status', '')}
                  className="hover:text-primary-900 transition-smooth"
                >
                  <Icon name="X" size={14} />
                </button>
              </span>
            )}
            {filters.matterType && (
              <span className="inline-flex items-center gap-1 px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-sm">
                Matter: {filters.matterType}
                <button
                  onClick={() => handleFilterChange('matterType', '')}
                  className="hover:text-primary-900 transition-smooth"
                >
                  <Icon name="X" size={14} />
                </button>
              </span>
            )}
            {filters.assignedLawyer && (
              <span className="inline-flex items-center gap-1 px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-sm">
                Advocate: {filters.assignedLawyer}
                <button
                  onClick={() => handleFilterChange('assignedLawyer', '')}
                  className="hover:text-primary-900 transition-smooth"
                >
                  <Icon name="X" size={14} />
                </button>
              </span>
            )}
            {filters.courtJurisdiction && (
              <span className="inline-flex items-center gap-1 px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-sm">
                Court: {filters.courtJurisdiction}
                <button
                  onClick={() => handleFilterChange('courtJurisdiction', '')}
                  className="hover:text-primary-900 transition-smooth"
                >
                  <Icon name="X" size={14} />
                </button>
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterPanel;